import { InternalAccountType } from "@wingspanhq/wingspan-api-sdk";
import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

/**
 * Account types offered in the Statements view. Selected via a single-choice
 * radio filter (never "All") — each value resolves to exactly one internal
 * account whose statements are listed.
 */
export const STATEMENT_ACCOUNT_TYPES = [
  InternalAccountType.BANKING,
  InternalAccountType.CLEARING,
  InternalAccountType.TAX_WITHHOLDING
] as const;

export const DEFAULT_STATEMENT_ACCOUNT_TYPE = InternalAccountType.BANKING;

export interface StatementsFilter extends UrlQueryFilter {
  /** One of {@link STATEMENT_ACCOUNT_TYPES}; defaults to Banking when absent. */
  accountType?: InternalAccountType;
}
